export const settingsKeys = {
    all: ['settings'] as const,
    schedules: () => [...settingsKeys.all, 'schedules'] as const,
    bookingRules: () => [...settingsKeys.all, 'booking-rules'] as const,
    bookingRulesExtra: () => [...settingsKeys.all, 'booking-rules-extra'] as const,
} as const; 